// SPDX-License-Identifier: GPL-2.0-or-later
// Rótulos das regras no formulário de preset do painel (OG-382, `PRESET_FIELDS` de @outgun/settings)
// e os textos do editor. Somente Latin-1.
export const SETTING_TEXTS_PT = {
    // editor
    // abas da moderação (OG-389)
    '$1 rooms': '$1 salas',
    '$1 players': '$1 jogadores',
    '$1 open reports': '$1 denúncias abertas',
    '$1 clans': '$1 clãs',
    'Moderate clan $1': 'Moderar o clã $1',
    '$1 active bans': '$1 bans ativos',
    '$1 people': '$1 pessoas',
    '$1 published maps': '$1 mapas publicados',
    'Used in kicks, bans and room messages': 'Usado em kicks, bans e mensagens à sala',
    'Empty room.': 'Sala vazia.',
    bot: 'bot',
    'Send the reason as a message': 'Enviar o motivo como mensagem',
    'Required; goes to the audit log.': 'Obrigatório; vai para a auditoria.',
    'The last 100 moderation actions; refreshes every 10 s.': 'As últimas 100 ações de moderação; atualiza a cada 10 s.',
    'No actions yet.': 'Nenhuma ação ainda.',
    'Send a map': 'Enviar um mapa',
    'The name players see in "Create room" and in the vote.': 'O nome que os jogadores veem em "Criar sala" e na votação.',
    'No maps sent yet.': 'Nenhum mapa enviado ainda.',
    'Open critical bugs': 'Bugs críticos abertos',
    'No feedback here.': 'Nenhum feedback aqui.',
    veteran: 'veterano',
    'No invites yet.': 'Nenhum convite ainda.',
    'Anonymous summaries sent by the players at the end of each match.': 'Resumos anônimos enviados pelos jogadores no fim de cada partida.',
    'Minutes played': 'Minutos jogados',
    Regions: 'Regiões',
    'Typical ping (ms)': 'Ping típico (ms)',
    'e.g. festival': 'ex.: festival',
    'What changes, in one line (appears in "Create room")': 'O que muda, numa linha (aparece em "Criar sala")',
    Categories: 'Categorias',
    'One rule per line, as in the gamemod file. Unknown lines show an error below.': 'Uma regra por linha, como no arquivo gamemod. Linha desconhecida mostra o erro abaixo.',
    'Same rules as Classic': 'Mesmas regras do Clássico',
    'Check a rule to change its value; the others stay as in Classic.': 'Marque uma regra para mudar o valor; as outras ficam como no Clássico.',
    'server default': 'padrão do servidor',
    'Search account': 'Buscar conta',
    name: 'nome',
    '$1 admins': '$1 admins',
    '$1 moderators': '$1 moderadores',
    '$1 accounts in total': '$1 contas no total',
    'No accounts found.': 'Nenhuma conta encontrada.',
    Created: 'Criada em',
    'Last seen': 'Último acesso',
    'Role of $1': 'Papel de $1',
    'New preset': 'Novo preset',
    'No presets created yet.': 'Nenhum preset criado ainda.',
    'Pick a preset on the left to see its rules, or create a new one.': 'Escolha um preset à esquerda para ver as regras, ou crie um novo.',
    'Lowercase, no spaces: it is how the preset appears in "Create room".': 'Minúsculas, sem espaço: é assim que o preset aparece em "Criar sala".',
    'Same rules as Classic. Turn on "change" in a rule to set it.': 'Mesmas regras do Clássico. Marque uma regra para mudar o valor.',
    '$1 rules different from Classic.': '$1 regras diferentes do Clássico.',
    'From the panel': 'Do painel',
    'From the game (read only)': 'Do jogo (só leitura)',
    'Duplicate to edit': 'Duplicar para editar',
    'Text mode (gamemod lines)': 'Modo texto (linhas de gamemod)',
    'Preview (generated lines)': 'Prévia (linhas geradas)',
    '(no changes: same as Classic)': '(sem mudanças: igual ao Clássico)',
    '$1 changed': '$1 alteradas',
    'Allowed: $1': 'Aceito: $1',
    'Default: $1': 'Padrão: $1',
    '$1 to $2': '$1 a $2',
    'at least $1': 'no mínimo $1',
    'at most $1': 'no máximo $1',
    '$1, or 0': '$1, ou 0',
    '0 to 32 items, or a %': '0 a 32 itens, ou uma %',
    items: 'itens',
    '% of rooms': '% das salas do mapa',
    unit: 'unidade',
    On: 'Sim',
    Balance: 'Equilibrar',
    Shuffle: 'Embaralhar',
    Normal: 'Normal',
    Special: 'Especial',
    'Health, energy and shooting': 'Vida, energia e tiro',
    'Power-ups': 'Power-ups',
    Physics: 'Física',
    // regras
    'Max players (even number)': 'Máximo de jogadores (número par)',
    'Minimum bots': 'Mínimo de bots',
    'Fill with bots up to (players)': 'Completar com bots até (jogadores)',
    'Bot balances the teams': 'Bot equilibra os times',
    'Bot ping (ms)': 'Ping dos bots (ms)',
    'Captures to win (0 = no limit)': 'Capturas para vencer (0 = sem limite)',
    'Lead needed to win (captures)': 'Vantagem para vencer (capturas)',
    'Time limit (minutes, 0 = none)': 'Tempo limite (minutos, 0 = sem)',
    'Extra time (minutes)': 'Prorrogação (minutos)',
    'Extra time periods': 'Períodos de prorrogação',
    'Sudden death': 'Morte súbita',
    'Pause between matches (seconds)': 'Pausa entre partidas (segundos)',
    'Extra pause per player (seconds)': 'Pausa extra por jogador (segundos)',
    'Dropped flag returns after (seconds)': 'Bandeira caída volta após (segundos)',
    'Minimum time to capture (seconds)': 'Tempo mínimo para capturar (segundos)',
    'Carrying the flag scores every (seconds, 0 = off)': 'Carregar a bandeira pontua a cada (segundos, 0 = não)',
    'Wild flag in a random place': 'Bandeira neutra em lugar aleatório',
    'Team flags locked': 'Bandeiras dos times travadas',
    'Wild flags locked': 'Bandeiras neutras travadas',
    'Capture on your own flag': 'Capturar na própria bandeira',
    'Capture on a wild flag': 'Capturar numa bandeira neutra',
    'Capture away from the base': 'Capturar longe da base',
    'Carry your own flag': 'Carregar a própria bandeira',
    'Flags always visible on the minimap': 'Bandeiras sempre visíveis no minimapa',
    'Team balance': 'Equilíbrio dos times',
    'Respawn time (seconds)': 'Tempo para renascer (segundos)',
    'Extra respawn time when alone (seconds)': 'Tempo extra para renascer sozinho (segundos)',
    'Respawn balancing time (seconds)': 'Tempo de equilíbrio do renascimento (segundos)',
    'Respawn wait after a deathbringer (seconds)': 'Espera para renascer após deathbringer (segundos)',
    'Spawn protection (seconds)': 'Proteção ao renascer (segundos)',
    'Everyone respawns on capture': 'Todos renascem na captura',
    'Free turning': 'Giro livre',
    'Players shown on the minimap': 'Jogadores mostrados no minimapa',
    'See rockets up to (rooms)': 'Ver foguetes até (salas do mapa)',
    'Player details on the minimap (0 to 2)': 'Detalhes dos jogadores no minimapa (0 a 2)',
    'Friendly fire': 'Fogo amigo',
    'Friendly deathbringer': 'Deathbringer amigo',
    'Rocket damage': 'Dano do foguete',
    'Starting health': 'Vida inicial',
    'Starting energy': 'Energia inicial',
    'Maximum health': 'Vida máxima',
    'Maximum energy': 'Energia máxima',
    'Health regeneration 0-100 (per second)': 'Regeneração de vida 0-100 (por segundo)',
    'Health regeneration 100-200 (per second)': 'Regeneração de vida 100-200 (por segundo)',
    'Health regeneration above 200 (per second)': 'Regeneração de vida acima de 200 (por segundo)',
    'Energy regeneration 0-100 (per second)': 'Regeneração de energia 0-100 (por segundo)',
    'Energy regeneration 100-200 (per second)': 'Regeneração de energia 100-200 (por segundo)',
    'Energy regeneration above 200 (per second)': 'Regeneração de energia acima de 200 (por segundo)',
    'Running costs health above': 'Correr gasta vida acima de',
    'Health lost running (per second)': 'Vida perdida correndo (por segundo)',
    'Energy lost running (per second)': 'Energia perdida correndo (por segundo)',
    'Energy per shot': 'Energia por tiro',
    'Energy per extra rocket': 'Energia por foguete extra',
    'Stun when hit (seconds)': 'Atordoamento ao ser atingido (segundos)',
    'Time between shots (seconds)': 'Tempo entre tiros (segundos)',
    'Time between shots with energy (seconds)': 'Tempo entre tiros com energia (segundos)',
    'Power-ups on the map, minimum (items or % of rooms)': 'Power-ups no mapa, mínimo (itens ou % das salas)',
    'Power-ups on the map, maximum (items or % of rooms)': 'Power-ups no mapa, máximo (itens ou % das salas)',
    'Power-up respawn (seconds)': 'Power-up reaparece após (segundos)',
    'Time added per power-up (seconds)': 'Tempo somado por power-up (segundos)',
    'Maximum power-up time (seconds)': 'Tempo máximo de power-up (segundos)',
    'Power-ups drop on death': 'Power-ups caem ao morrer',
    'Power-ups per player': 'Power-ups por jogador',
    'Maximum weapon level': 'Nível máximo da arma',
    'Megahealth bonus': 'Bônus do megahealth',
    'Power damage multiplier': 'Multiplicador de dano do power',
    'Deathbringer duration (seconds)': 'Duração do deathbringer (segundos)',
    'Deathbringer can be switched off': 'Deathbringer pode ser desligado',
    'Deathbringer health limit': 'Limite de vida do deathbringer',
    'Deathbringer energy limit': 'Limite de energia do deathbringer',
    'Deathbringer health loss (per second)': 'Perda de vida do deathbringer (por segundo)',
    'Deathbringer energy loss (per second)': 'Perda de energia do deathbringer (por segundo)',
    'Shadow is fully invisible (0 or 1)': 'Shadow totalmente invisível (0 ou 1)',
    'Shadow sees shadows': 'Shadow vê outros shadows',
    'Shield hits (0 = unlimited)': 'Golpes do escudo (0 = ilimitado)',
    'Chance of shield': 'Chance de escudo',
    'Chance of turbo': 'Chance de turbo',
    'Chance of shadow': 'Chance de shadow',
    'Chance of power': 'Chance de power',
    'Chance of weapon': 'Chance de arma',
    'Chance of megahealth': 'Chance de megahealth',
    'Chance of deathbringer': 'Chance de deathbringer',
    'Start with shield': 'Começar com escudo',
    'Start with turbo (seconds)': 'Começar com turbo (segundos)',
    'Start with shadow (seconds)': 'Começar com shadow (segundos)',
    'Start with power (seconds)': 'Começar com power (segundos)',
    'Starting weapon level': 'Nível inicial da arma',
    'Start with deathbringer': 'Começar com deathbringer',
    'Shield for the whole team': 'Escudo para o time todo',
    'Turbo for the whole team': 'Turbo para o time todo',
    'Shadow for the whole team': 'Shadow para o time todo',
    'Power for the whole team': 'Power para o time todo',
    'Weapon for the whole team': 'Arma para o time todo',
    'Megahealth for the whole team': 'Megahealth para o time todo',
    'Deathbringer for the whole team': 'Deathbringer para o time todo',
    Friction: 'Atrito',
    Drag: 'Arrasto',
    Acceleration: 'Aceleração',
    'Brake (x acceleration)': 'Freio (x aceleração)',
    'Turning (x acceleration)': 'Giro (x aceleração)',
    'Running (x acceleration)': 'Corrida (x aceleração)',
    'Turbo (x acceleration)': 'Turbo (x aceleração)',
    'Carrying a flag (x acceleration)': 'Com bandeira (x aceleração)',
    'Player collisions': 'Colisão entre jogadores',
    'Rocket speed': 'Velocidade do foguete',
};
//# sourceMappingURL=setting-texts.js.map